/**
 * @file
 * A cross-platform helper for loading scripts.
 * @param {string} url - The JS URL to load.
 * @param {Object} [props] - Additional key/values for the script tag.
 * @returns {Promise} - Resolves/Rejects upon completion.
 */

export default function loadjs(url, props = {}) {
	const script = document.createElement("script");
	script.type = "text/javascript";
	script.src = url;
	Object.keys(props).forEach((key) => {
		script[key] = props[key];
	});

	return new Promise((resolve, reject) => {
		// ie
		if (script.readyState) {
			script.onreadystatechange = () => {
				if (script.readyState === "loaded" || script.readyState === "complete") {
					script.onreadystatechange = null;
					resolve();
				}
			};
		}

		// other browsers
		else {
			script.onload = resolve;
			script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
		}

		document.getElementsByTagName("head")[0].appendChild(script);
	});
}



// WEBPACK FOOTER //
// ./src/shared/util/loadjs.js